var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowsExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1818 18.0001L16.0574 16.8556L20.6754 12.2578H10.6364V10.6515H20.6754L16.0574 6.03355L17.1818 4.90918L23.7273 11.4546L17.1818 18.0001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54549 13.0909L7.66986 11.9465L3.0519 7.34858H13.0909V5.74233H3.0519L7.66986 1.12437L6.54549 0L3.33786e-05 6.54545L6.54549 13.0909Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsExchange);
export default __webpack_public_path__ + "static/media/arrowsExchange.44457ccb84f6983e7241a13e644b6b57.svg";
export { ForwardRef as ReactComponent };